/* eslint-disable react-hooks/exhaustive-deps */
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useLazyGetAllPillsQuery } from "../../../../services/gallusTools";

interface TileDetailsModalProps {
  selectedTileID: number;
  modalIsOpen: boolean;
  updateTileFunction: (title: string, url: string) => void;
  toggleModal: () => void;
}

export const TileDetailsModal = (props: TileDetailsModalProps) => {
  const [TileTitle, setTileTitle] = useState<string>("");
  const [TileLink, setTileLink] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  const [getTilesQuery, getTilesQueryResult] = useLazyGetAllPillsQuery(); //TODO: Change this to a id get query

  useEffect(() => {
    if (
      getTilesQueryResult.isSuccess &&
      getTilesQueryResult.status === "fulfilled" &&
      props.selectedTileID
    ) {
      const currentTileData = getTilesQueryResult.data.find(
        (Tile) => Tile.id === props.selectedTileID,
      );

      if (currentTileData) {
        setTileTitle(currentTileData.title);
        setTileLink(currentTileData.link);
        setLoading(false);
      }
    }
  }, [getTilesQueryResult]);

  useEffect(() => {
    getTilesQuery();
  }, [props.selectedTileID]);

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>User Details</ModalHeader>
      <div>
        <ModalBody>
          {loading && (
            <div className="loading-div">
              <FontAwesomeIcon
                icon={faSpinner}
                size="2x"
                spin={true}
                style={{ margin: "0 auto" }}
              />
            </div>
          )}
          {!loading && (
            <div>
              <div>Details for selected tile</div>
              <hr></hr>
              <div>Title</div>
              <div>
                <input
                  value={TileTitle}
                  onChange={(e) => {
                    setTileTitle(e.target.value);
                  }}
                  className="form-control"
                />
              </div>
              <div>Formatted link</div>
              <div>
                <input
                  value={TileLink}
                  onChange={(e) => {
                    setTileLink(e.target.value);
                  }}
                  className="form-control"
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              props.updateTileFunction(TileTitle, TileLink);
              props.toggleModal();
            }}
          >
            Update
          </Button>
          <Button color="secondary" onClick={() => props.toggleModal()}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};
